import React from 'react'
import { Col } from 'react-bootstrap'
import { StyledRow, StyledTitle, StyledSubtitle, StyledDate, StyledContent, StyledImage } from './styled'
import { Button } from './../../components'
import { useHistory } from 'react-router-dom'
import { formatDate } from './../../common'

const News = (props) => {
    const history = useHistory()

    return (
        <StyledRow className='mx-0 px-0 d-flex align-items-center flex-row-reverse flex-column-reverse flex-lg-row'>
            <Col
                lg={{
                    span: 5,
                    offset: 1
                }}
                xs={{
                    span: 10,
                    offset: 1
                }}
                className='py-5'
            >
                <StyledTitle>
                    {props.title}
                </StyledTitle>
                <StyledSubtitle>
                    {props.subtitle}
                </StyledSubtitle>
                <StyledDate>
                    {
                        formatDate(props.date)
                    }
                </StyledDate>
                <StyledContent dangerouslySetInnerHTML={{__html: props.text}} />

                {
                    props?.button?.title && (
                        <Button label={props.button.title} />
                    )
                }
            </Col>

            <Col 
                lg={{
                    span: 5,
                    offset: 1
                }}
                xs={{
                    span: 12,
                }}
                className='px-0'
            >
                <StyledImage src={props.image?.url}/>
            </Col>
        </StyledRow>
    )
}

export default News